import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ac-variants-coverages-row-value',
  templateUrl: './ac-variants-coverages-row-value.component.html',
  styleUrls: ['./ac-variants-coverages-row-value.component.scss']
})
export class AcVariantsCoveragesRowValueComponent implements OnInit {

  @Input() value: string | boolean;
  icon: string;

  constructor() { }

  ngOnInit() {
    if (typeof this.value === 'boolean') {
      this.icon = this.value ? 'check' : '—';
    }
  }

}
